import { render, staticRenderFns } from "./ServiceResults.vue?vue&type=template&id=59793734&"
import script from "./ServiceResults.vue?vue&type=script&lang=js&"
export * from "./ServiceResults.vue?vue&type=script&lang=js&"
import style0 from "./ServiceResults.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports